export default function HLCAreaPrimitive(overlay, ctx, layout, candles) {
    
    if (candles.length < 2) return
    
    ctx.strokeStyle = overlay.lineColor
    ctx.fillStyle = overlay.fillColor
    ctx.lineWidth = overlay.lineWidth
    ctx.lineCap = 'round'
    ctx.lineJoin = 'round'
    
    // Calculate average of high, low, and close for each candle
    let hlcPoints = candles.map(candle => {
        const [timestamp, open, high, low, close, volume] = candle.raw
        const hlcAvg = (high + low + close) / 3
        return {
            x: layout.t2screen(timestamp),
            y: layout.$2screen(hlcAvg),
            value: hlcAvg
        }
    })
    
    ctx.beginPath()
    
    // Start from the first point
    ctx.moveTo(hlcPoints[0].x, hlcPoints[0].y)
    
    // Draw line through all HLC average points
    for (let i = 1; i < hlcPoints.length; i++) {
        ctx.lineTo(hlcPoints[i].x, hlcPoints[i].y)
    }
    
    // Complete the area by drawing down to the bottom and back to start
    let lastPoint = hlcPoints[hlcPoints.length - 1]
    let bottomY = layout.height // Use full height of chart area
    
    ctx.lineTo(lastPoint.x, bottomY)
    ctx.lineTo(hlcPoints[0].x, bottomY)
    ctx.closePath()
    
    // Fill the area first, then stroke the line
    ctx.fill()
    
    // Redraw just the line on top
    ctx.beginPath()
    ctx.moveTo(hlcPoints[0].x, hlcPoints[0].y)
    for (let i = 1; i < hlcPoints.length; i++) {
        ctx.lineTo(hlcPoints[i].x, hlcPoints[i].y)
    }
    ctx.stroke()
}
